module.exports = __webpack_public_path__ + "img/ikon-de_l.26d4cb66.png";